export default __webpack_public_path__ + "assets/images/Data-Transparency-21233fc8eddca84bfefa62196a1d586a.svg";